import { render, staticRenderFns } from "./ContactsSolutionsBlock.vue?vue&type=template&id=7d22ac0f"
import script from "./ContactsSolutionsBlock.vue?vue&type=script&lang=js"
export * from "./ContactsSolutionsBlock.vue?vue&type=script&lang=js"
import style0 from "./ContactsSolutionsBlock.vue?vue&type=style&index=0&id=7d22ac0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports